import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import './styles.css';

class FooterValue extends Component {
	render() {
		const { variable, unit, multiplier } = this.props;
		return (
			<div className="sales-test-layout-footer-value">
				{numeral(variable.value*(multiplier||1)).format('0,0.00')} {unit}
			</div>
		);
	}
}

FooterValue.propTypes = {
	variable: PropTypes.object.isRequired
};
export default FooterValue;
